import { Link } from 'react-router';
import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 0 auto;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 800px;

	@media (max-width: 992px) {
		max-width: 100%;
		text-align: center;
	}
`;

export const MainTitle = styled.div`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 32px;
		text-align: center;
	}
`;

export const Container = styled.div`
	margin-top: 32px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 12px;
	background: ${({ theme }) => theme.gradient.backgroundProfile};
	padding: 18px 12px 12px 42px;

	@media (max-width: 992px) {
		flex-direction: column;
		padding: 12px;
		background: ${({ theme }) => theme.gradient.backgroundProfile};
	}
`;

export const Title = styled.h2`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 24px;
		line-height: 1.32;
		margin-bottom: 24px;
	}
`;

export const LinkStyled = styled(Link)`
	display: inline-flex;
	align-items: center;
	margin-top: 48px;

	@media (max-width: 992px) {
		margin: 0 auto;
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	max-width: 510px;
	width: 100%;

	img {
		width: 100%;
		mix-blend-mode: lighten;
	}
`;
